import createElementFromNode from './createElementFromNode';
import {allLogTypes as logTypes} from '@servicenow/ui-internal';
import log from './log';

/**
 * Creates an element for the virtual DOM from a string of HTML. WARNING: This method does not
 * sanitize the HTML string passed to it. If you use this method you may be vulnerable to
 * XSS attacks if you do not take the right precautions.
 *
 * @method createElementFromString
 * @param {String} html String of html to parse and convert to a vnode
 * @returns {VNode} The vnode to use in the virtual DOM
 */
export default function createElementFromString(html) {
	log(
		'createElementFromString has been deprecated. Please use dangerouslyCreateElementFromString and make sure you are taking the necessary precautions to prevent XSS attacks',
		{level: logTypes.ERROR, origin: 'createElementFromString'}
	);

	if (!document || !document.createElement) return;

	const element = document.createElement('div');
	element.innerHTML = html;
	return createElementFromNode(element.firstChild);
}
